export const errMsg = {
  100014: '登陆失效，请重新登录',
  100023: '没有操作权限'
}
